// Lifted verbatim from `src/hooks/useLatestRef.ts`. Every importer and every
// mock now names `@heidi/utils` directly.
//
// It lands HERE rather than in a domain package because it is measured shared:
// 23 production importers across agents, sessions, projects, copilot, haiku,
// medical-director and side-by-side evidence. `@heidi/utils` already hosts
// React hooks behind its root door (`useIsomorphicLayoutEffect`,
// `useWindowDimensions`) and already declares `react` as a peer, so this adds
// no new door and no new shared surface — it is the existing one.
//
// BASENAME: kept camelCase against this package's kebab-case neighbours. A file
// moved into a package keeps its original basename (repo-wide rule) so the move
// stays reviewable as a move.
import { useRef } from 'react';

export const useLatestRef = <T>(value: T) => {
  const latestRef = useRef(value);
  latestRef.current = value;
  return latestRef;
};
